import { Contract } from "../contracts/Contract";

export class EthService {
  protected providerUrl = "";

  private contracts: any = {};
  private wallet: any = null;

  protected constructor(providerUrl: string) {
    this.providerUrl = providerUrl;
  }

  public async connect() {
    if (this.wallet) {
      return this.wallet.connect(this.providerUrl);
    }
  }

  public isConnected(): boolean {
    return this.wallet && this.wallet.isConnected();
  }

  public isUnlocked(): boolean {
    return this.isConnected() && this.getAddress() !== undefined;
  }

  public disconnect() {
    this.wallet.disconnect();
    this.contracts = {};
  }

  public setWallet(wallet: any) {
    this.wallet = wallet;
  }

  public getWallet(): any {
    return this.wallet;
  }

  public getWalletIcon(): any {
    return this.wallet.getIcon();
  }

  public getEthProvider() {
    return this.wallet.getEthProvider();
  }

  public async setContracts(contracts: Contract[]) {
    if (!this.isConnected()) {
      // make sure the wallet is connected before the call
      console.debug("Wallet is disconnected. Connecting...");
      await this.connect();
    }

    for (const contract of contracts) {
      if (typeof contract === "object" && contract instanceof Contract) {
        contract.initInstance(this.getEthProvider());
        this.contracts[contract.getName()] = contract;
      } else {
        console.error("The parameter is not instance of a contract", contract);
        continue;
      }
    }
  }

  public async sendTransaction(txParams: any): Promise<any> {
    if (!this.wallet) {
      throw new Error("Connect a wallet first.");
    }

    for (const x of ["to", "data"]) {
      if (x in txParams === false) {
        throw new Error(`Missing required param ${x}`);
      }
    }

    return this.wallet.sendTransaction(txParams);
  }

  public async balance() {
    return this.wallet.getBalance();
  }

  public async waitTxReceipt(txHash: string, interval: number): Promise<any> {
    for (;;) {
      const provider = this.wallet.getEthProvider();
      const receipt = await provider.getTransactionReceipt(txHash);

      if (receipt !== null) {
        return receipt;
      }

      await new Promise((resolve) => setTimeout(resolve, interval));
    }
  }

  public getAddress(): string {
    if (!this.wallet) {
      throw new Error(
        "The current wallet/provider doesn't have any linked account"
      );
    }
    return this.wallet.getAddress();
  }

  public getChain(): string {
    if (!this.wallet) {
      throw new Error(
        "The current wallet/provider doesn't have any linked account"
      );
    }
    return this.wallet.getChain();
  }
}
